import React, { useState, useContext, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { AuthContext } from "../../Context/AuthContext";
import { showLoader, hideLoader, withBackendUrl } from "../../utils/helpers";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ThemeContext } from "../../hooks/useThemeContext";
import EventAction from "../../Actions/event.service";
import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";
import BottomBtn from "../BottomToTop";
import useSoloEvent from "../../hooks/useSoloEvent";
import { CategoriesSku } from "../../utils/CategoriesSku";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { useRef } from "react";

function SelectGiftCard() {
  // Gift Modal Open
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const isSolo = useSoloEvent();
  const { backUrlContext, setBackUrlContext } = useContext(ThemeContext);
  const { eventData, setIsLoggedIn, setIsSidebarVisible } =
    useContext(AuthContext);
  const { showSuccessToast } = useContext(ThemeContext);

  const [Giftshow, setGiftShow] = useState(false);
  const [giftModal, setGiftModal] = useState([]);
  const [giftCardType, setGiftCardType] = useState("");
  const [giftCardTypeList, setGiftCardTypeList] = useState([]);
  const [giftCardTypelistOriginal, setGiftCardTypelistOriginal] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [initialCategory, setInitialCategory] = useState([]);
  const isFirstRender = useRef(true);
  const [allSelected, setAllSelected] = useState(false);
  console.log(isFirstRender, "isFirstRender");

  useEffect(() => {
    setBackUrlContext(`/${localStorage.getItem("role") ?? "organiser"}/${id}`);

    if (isFirstRender.current) {
      // On initial mount only — fetch all categories
      getGiftCards(selectedCategory);
      isFirstRender.current = false;
    }
  }, []);
  useEffect(() => {
    if (!isFirstRender.current) {
      getGiftCards(initialCategory); // only after "Done" clicked
    }
  }, [initialCategory]);

  const handleGiftClose = () => {
    setGiftShow(false);
    closeModal();
  };
  const handleGiftShow = (giftId) => {
    setGiftModal(giftId);
    setGiftShow(true);
    openModal();
  };

  const openModal = () => {
    const scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
  };

  const closeModal = () => {
    const scrollY = Math.abs(parseInt(document.body.style.top || "0"));
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, scrollY);
  };

  const getUniqueCategories = () => {
    if (eventData?.isSolo) {
      const categoryMap = new Map();
      CategoriesSku.forEach((cat) => {
        if (!categoryMap.has(cat.category)) {
          categoryMap.set(cat.category, cat);
        } else {
        }
      });
      return Array.from(categoryMap.values());
    } else {
      return CategoriesSku.filter(
        (cat) => cat.suggestedFor === "Group & Solo Gifting"
      );
    }
  };

  const getGiftCards = (selectedCategory = null) => {
    showLoader();

    EventAction.getGiftCards()
      .then((res) => {
        let temp_cards = [];

        if (!eventData?.isSolo) {
          temp_cards = res.filter((card) => card.price.type === "RANGE");
        } else {
          temp_cards = res;
        }

        temp_cards = temp_cards.filter(
          (card) =>
            ![
              "EGCGBBOATBB001",
              "EGCGBIBG001",
              "EGCGBRDM001",
              "EGCGBRDM002",
              "EGCGBSYNFKC001",
            ].includes(card.sku)
        );

        console.log(temp_cards, "temp_cards");

        const categorySkuMap = new Map();

        CategoriesSku.forEach((cat) => {
          if (
            !eventData?.isSolo &&
            cat.suggestedFor !== "Group & Solo Gifting"
          ) {
            return;
          }

          if (!categorySkuMap.has(cat.category)) {
            categorySkuMap.set(cat.category, new Set(cat.sku));
          } else {
            cat.sku.forEach((sku) => categorySkuMap.get(cat.category).add(sku));
          }
        });

        if (selectedCategory && selectedCategory.length > 0) {
          const filteredSkus = new Set();

          selectedCategory.forEach((cat) => {
            const skuSet = categorySkuMap.get(cat);
            if (skuSet) {
              skuSet.forEach((sku) => filteredSkus.add(sku));
            }
          });

          temp_cards = temp_cards.filter((card) => filteredSkus.has(card.sku));
        }

        const categoryWiseCards = {};
        categorySkuMap.forEach((skuSet, category) => {
          const matchedCards = temp_cards.filter((card) =>
            skuSet.has(card.sku)
          );
          categoryWiseCards[category] = matchedCards;
        });

        console.log("Category-wise Gift Cards", categoryWiseCards);
        console.log(temp_cards, "Filtered Gift Cards");

        setGiftCardTypeList(temp_cards);
        setGiftCardTypelistOriginal(temp_cards);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.message === "Unauthorized User.") {
          localStorage.removeItem("token");
          setIsLoggedIn(false);
          setIsSidebarVisible(false);
          navigate("/");
        }
        hideLoader();
      });
  };

  const submitgiftCardType = async () => {
    showLoader();
    const data = new FormData();
    data.append("giftCardType", giftCardType);
    console.log(eventData?._id, "eventData?._id");
    EventAction.selectGiftCard(data, eventData?._id)
      .then((res) => {
        hideLoader();
        showSuccessToast("Gift Card has been Selected");
        navigate(`/organiser/${eventData?._id}`);
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      });
  };
  function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, index) => val === sortedB[index]);
  }

  const handleSearchChange = (e) => {
    const inputValue = e.target.value.toLowerCase();
    setSearchValue(inputValue);
    // let duplicateGiftCardTypeList = [...giftCardTypelistOriginal];
    // const filteredGiftCards = duplicateGiftCardTypeList.filter((giftCard) =>
    //   // giftCard.name.toLowerCase().includes(inputValue)
    //   giftCard.name.toLowerCase().startsWith(inputValue)
    // );
    // setGiftCardTypeList(filteredGiftCards);
  };

  const handleCloseModal = (e) => {
    setShowModal(false);
    closeModal();
  };
  const isSelectionChanged = !arraysEqual(initialCategory, selectedCategory);
  console.log(isSelectionChanged, "isSelectionChanged");

  useEffect(() => {
    const isSafari = () => {
      const userAgent = navigator.userAgent;
      return userAgent.includes("Safari") && !userAgent.includes("Chrome");
    };

    if (isSafari()) {
      document.querySelector("body").classList.add("is-safari");
    } else {
      document.querySelector("body").classList.add("not-safari");
    }
  }, []);

  function formatTermsAsList(htmlString) {
    if (!htmlString) return "";

    // Split the string by <br> or line breaks
    const lines = htmlString.split(/<br\s*\/?>|\n/);

    // Wrap each non-empty line in <li>
    const listItems = lines
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => `<li>${line}</li>`)
      .join("");

    // Wrap the list items in a <ul>
    return `<ul>${listItems}</ul>`;
  }

  console.log(giftCardTypelistOriginal, "giftCardType");
  const filteredList = giftCardTypeList.filter((element) =>
    element.name.toLowerCase().startsWith(searchValue.toLowerCase())
  );
  useEffect(() => {
    const allCategories = getUniqueCategories().map((cat) => cat.category);
    setSelectedCategory(allCategories);
    setInitialCategory(allCategories);
    setAllSelected(true);
  }, []);

  const allCategories = getUniqueCategories().map((cat) => cat.category);
  const isAllSelected =
    selectedCategory.length === allCategories.length &&
    allCategories.every((cat) => selectedCategory.includes(cat));

  console.log(giftModal, "giftModal");

  return (
    <>
      <h4 className="titleevent">Gift Options</h4>
      <div className="SelectGiftCard">
        <h4>Select Gift Card</h4>
        <Sidebar collapsed={collapsed} className="sidebar-wrapper">
          <Menu>
            <MenuItem
              onClick={(e) => {
                e.preventDefault();
                setCollapsed(!collapsed);
              }}
            >
              <img src="/images/cross.png" alt="Close Icon" />
            </MenuItem>
            <MenuItem
              className={selectedCategory.length === 0 && "activeMenu"}
              onClick={() => {
                if (isAllSelected) {
                  setSelectedCategory([]);
                } else {
                  setSelectedCategory(allCategories);
                }
              }}
            >
              All Categories
              <input type="checkbox" checked={isAllSelected} readOnly />
              {/* } */}
            </MenuItem>
            <div
              style={{
                overflowY: "scroll",
                height: "75vh",
                paddingBottom: "50px",
              }}
            >
              {getUniqueCategories().map((cat) => {
                const isActive = selectedCategory.includes(cat.category);
                return (
                  <MenuItem
                    key={cat.category}
                    className={isActive ? "activeMenu" : ""}
                    onClick={() => {
                      const updated = isActive
                        ? selectedCategory.filter((c) => c !== cat.category)
                        : [...selectedCategory, cat.category];
                      setSelectedCategory(updated);
                    }}
                  >
                    {cat.category} <input type="checkbox" checked={isActive} />
                  </MenuItem>
                );
              })}
            </div>
            <MenuItem
              className="doneBtn"
              disabled={selectedCategory.length === 0 || !isSelectionChanged}
              onClick={(e) => {
                e.preventDefault();
                setInitialCategory([...selectedCategory]);
                setCollapsed(true);
                getGiftCards(selectedCategory);
              }}
            >
              Done
            </MenuItem>
          </Menu>
        </Sidebar>

        <div className="search-wrapper mb-4">
          <div
            className="filter-wrapper"
            style={{ background: selectedCategory.length > 0 ? "#c01048" : "" }}
            onClick={() => setCollapsed((prev) => !prev)}
          >
            <img
              src={
                selectedCategory.length > 0
                  ? "/images/filter-icon-white.png"
                  : "/images/filter-icon.svg"
              }
              alt="Filter Icon"
            />
          </div>
          <input
            type="text"
            className="form-control"
            placeholder="Search.."
            onChange={(e) => handleSearchChange(e)}
            value={searchValue}
          />
        </div>
        <p>Currently we allow to choose only one gift card</p>
        {/* {initialCategory.length > 0 && (
          <p>Showing results for {initialCategory.join(", ")}</p>
        )} */}
        {initialCategory.length > 0 &&
          !(
            initialCategory.length === allCategories.length &&
            allCategories.every((cat) => initialCategory.includes(cat))
          ) && <p>Showing results for {initialCategory.join(", ")}</p>}

        {/* <div className="allcardslist">
          {giftCardTypeList.length > 0 ? (
            
            giftCardTypeList.map((element, index) => (
              
              <React.Fragment key={index}>
                {}
                <label
                  className={
                    element?.isPriority
                      ? "CardCustomcheck topLabel"
                      : "CardCustomcheck"
                  }
                >
                  {console.log(
                    giftCardType,
                    "GiftCardTypeGiftCardTypeGiftCardTypeGiftCardType"
                  )}
                  <Form.Control
                   
                    name="radio"
                    value={element?.name}
                    onClick={(e) => {
                      setGiftCardType(e.target.value);
                      handleGiftShow(element);
                      console.log(element, "Selected & updated gift card type");
                    }}
                  />
                  <div className="check-detail">
                    <div className="carddetail">
                      <img src={withBackendUrl(element?.icon)} alt="giftlogo" />
                    </div>
                    <div className="cardheaderbar">
                      <div className="cardheader">
                      
                        {element?.name}
                      </div>
                   
                    </div>
                  </div>
                  <span className="checkmark"></span>
                </label>
              </React.Fragment>
            ))
          ) : (
            <div className="when-no-wish"> No Gift Cards Found</div>
          )}
        </div> */}

        <div className="allcardslist">
          {filteredList.length > 0 ? (
            filteredList.map((element, index) => {
              const isMatch = element.name
                .toLowerCase()
                .startsWith(searchValue);

              return (
                <React.Fragment key={index}>
                  <label
                    style={{
                      display: !isMatch && searchValue ? "none" : "block",
                    }}
                    className={
                      element?.isPriority
                        ? "CardCustomcheck topLabel"
                        : "CardCustomcheck"
                    }
                  >
                    <Form.Control
                      name="radio"
                      value={element?.name}
                      onClick={(e) => {
                        setGiftCardType(e.target.value);
                        handleGiftShow(element);
                      }}
                    />
                    <div className="check-detail">
                      <div className="carddetail">
                        <img
                          src={withBackendUrl(element?.icon)}
                          alt="giftlogo"
                        />
                      </div>
                      <div className="cardheaderbar">
                        <div className="cardheader">{element?.name}</div>
                      </div>
                    </div>
                    <span className="checkmark"></span>
                  </label>
                </React.Fragment>
              );
            })
          ) : (
            <div className="when-no-wish">No Gift Cards Found</div>
          )}
        </div>

        <BottomBtn />
      </div>

      <Modal
        className="Createevent-modal giftcardmodal"
        show={Giftshow}
        onHide={handleGiftClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Gift Card Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modalgiftcard-wrapper">
            <div className="gift-img">
              <img
                src={withBackendUrl(giftModal?.icon)}
                alt="gift card image"
              />
            </div>
            <div className="denominatebar">
              <h5>Denomination</h5>
              <ul>
                <li>
                  Minimum ₹
                  {parseFloat(giftModal?.minimumAmount).toLocaleString("en-US")}
                </li>
                <li>
                  Maximum ₹
                  {parseFloat(giftModal?.maximumAmount).toLocaleString("en-US")}
                </li>
              </ul>
            </div>
            <Accordion className="modalaccordion" defaultActiveKey="0">
              <Accordion.Item eventKey="description">
                <Accordion.Header>Description</Accordion.Header>
                <Accordion.Body>
                  <p
                    className="post__content"
                    dangerouslySetInnerHTML={{
                      __html: giftModal?.description,
                    }}
                  ></p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="condition">
                <Accordion.Header>Terms & Conditions</Accordion.Header>
                <Accordion.Body>
                  <p
                    className="post__content"
                    dangerouslySetInnerHTML={{
                      __html: formatTermsAsList(
                        giftModal?.termAndCondition || ""
                      ),
                    }}
                  ></p>
                </Accordion.Body>
              </Accordion.Item>
              {/* <Accordion.Item eventKey="redeem">
                <Accordion.Header>How to Redeem</Accordion.Header>
                <Accordion.Body>
                  <p
                    className="post__content"
                    dangerouslySetInnerHTML={{
                      __html: giftModal?.howToRedeem,
                    }}></p>
                </Accordion.Body>
              </Accordion.Item> */}
            </Accordion>
            <br />
            <Button
              type="button"
              className="btn-pink"
              onClick={(e) => {
                console.log(eventData, "eventData");
                if (!eventData?.isSolo) {
                  console.log("not solo");
                  setShowModal(true);
                  handleGiftClose();
                  openModal();
                } else {
                  submitgiftCardType();
                  closeModal();
                }
              }}
            >
              Confirm gift for {eventData?.name}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="Createevent-modal fixamountpopup dateadded-popup"
        show={showModal}
        onHide={handleCloseModal}
      >
        <Modal.Header className="faviconadded" closeButton>
          weGroup
        </Modal.Header>
        <Modal.Body>
          Alert: When selecting a gift card from the catalog in our beta
          version, please be aware that the chosen gift card cannot be changed
          after invitation acceptance from the participants. Ensure group
          consensus before making a choice. Continue?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={() => {
              submitgiftCardType();
              closeModal();
            }}
            className="btn-pink"
          >
            Yes
          </button>
          <Button className="btngray" onClick={handleCloseModal} type="button">
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SelectGiftCard;
